import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

// Options
let options = {
  theme: {
    themes: {
      dark: {
        primary: '#ff4081',
        secondary: '#424242',
        accent: '#ff4081',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
};

export default new Vuetify(options);
